import gql from 'graphql-tag';
import { DocumentFields } from '../documentation/DocumentationFragments';

export default gql`
    fragment Certification on Funeral {
        Certification {
            ID
            TypeOfBdmDeathCertificate
            #DoctorsName
            #DoctorsCode
            #DoctorsAddress
            CoronersType
            #CoronersName
            #CoronersCode
            #CoronersDistrict
            #DisposalOrder
            CoronersCause
            Doctor {
                ID
                Name
            }
            Hospital {
                ID
                Name
            }
            Coroner {
                ID
                Name
                District
            }
            Referee {
                ID
                Name
            }
            RefereePurchaseOrder {
                ID
                Invoice {
                    ID
                    XeroID
                }
            }
            HospitalPurchaseOrder {
                ID
                Invoice {
                    ID
                    XeroID
                }
            }
            DoctorPurchaseOrder {
                ID
                Invoice {
                    ID
                    XeroID
                }
            }
            FileCorDisposalOrder {
                ${DocumentFields}
                RequiredDocument {
                    ID
                    Status
                }
            }
            FileMedCertCause {
                ${DocumentFields}
                RequiredDocument {
                    ID
                    Status
                }
            }
            FileStatDecForm {
                ${DocumentFields}
                RequiredDocument {
                    ID
                    Status
                }
            }
            FileCorCremPermit {
                ${DocumentFields}
                RequiredDocument {
                    ID
                    Status
                }
            }
            FileCremCertificate {
                ${DocumentFields}
                RequiredDocument {
                    ID
                    Status
                }
            }
            FileCremBookingForm {
                ${DocumentFields}
                RequiredDocument {
                    ID
                    Status
                }
            }
            FileCremContractForm {
                ${DocumentFields}
                RequiredDocument {
                    ID
                    Status
                }
            }
            FileRefereeingDoctorForm {
                ${DocumentFields}
                RequiredDocument {
                    ID
                    Status
                }
            }
            FileBurialBookingForm {
                ${DocumentFields}
                RequiredDocument {
                    ID
                    Status
                }
            }
            FileEmbalmingCert {
                ${DocumentFields}
                RequiredDocument {
                    ID
                    Status
                }
            }
            FileDisclaimer {
                ${DocumentFields}
                RequiredDocument {
                    ID
                    Status
                }
            }
        }
    }
`;

export const Prearrangement = gql`
    fragment PrearrangementCertification on Prearrangement {
        Certification {
            ID
            TypeOfBdmDeathCertificate
            #DoctorsName
            #DoctorsCode
            #DoctorsAddress
            CoronersType
            #CoronersName
            #CoronersCode
            #CoronersDistrict
            #DisposalOrder
            CoronersCause
            Doctor {
                ID
                Name
            }
            Hospital {
                ID
                Name
            }
            Coroner {
                ID
                Name
                District
            }
            Referee {
                ID
                Name
            }
        }
    }
`;

/*
 */
